"use client"

import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    style={{ backgroundColor: 'rgba(21,128,61,0.08)' }}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full shadow-[0px_0px_0px_2px_rgba(21,128,61,0.08)]",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn("h-full w-full flex-1  transition-all rounded-full shadow-[inset_0px_0px_0px_1px_rgba(0,0,0,0.2)]")}
      style={{ width: `${value}%`, backgroundColor: '#f1fdf8' }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
